<div *ngIf="(isMobile$ | async) === false">
  <table mat-table [dataSource]="devices">
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex flex-col gap-6">
          <div class="flex items-center gap-3">
            <sbnb-icon [size]="16" icon="padlock" class="text-night-lighter"></sbnb-icon>
            <a class="clickable">{{ element.name }}</a>
            <sbnb-cs-debug-item
              label="Lock ID"
              (click)="$event.stopPropagation()"
              [coreNovaLink]="'/dashboards/smartlocks?lock-id=' + element.id"
              [value]="element.id"
              linkLabel="Nova"></sbnb-cs-debug-item>
          </div>

          <div *ngIf="element.device_properties.keypad" class="accessory-keypad relative flex items-center gap-3 pl-6">
            <img src="assets/iconography/keypad.svg" />
            <a class="clickable">Accessory keypad</a>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Battery Column -->
    <ng-container matColumnDef="battery">
      <th mat-header-cell *matHeaderCellDef>Battery</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex flex-col gap-6">
          <sbnb-device-battery-status [battery]="element.device_properties.battery"></sbnb-device-battery-status>

          <sbnb-device-battery-status
            *ngIf="element.device_properties.keypad"
            [battery]="element.device_properties.keypad.battery"></sbnb-device-battery-status>
        </div>
      </td>
    </ng-container>

    <!-- Online Column -->
    <ng-container matColumnDef="online">
      <th mat-header-cell *matHeaderCellDef>Online</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex flex-col gap-6">
          <img
            *ngIf="element.device_properties.online"
            src="assets/iconography/online-antenna.svg"
            class="device-status-icon"
            alt="online" />
          <img
            *ngIf="!element.device_properties.online"
            src="assets/iconography/offline-antenna.svg"
            class="device-status-icon"
            alt="offline"
            [matTooltip]="element.issues | deviceIssuesTooltip" />

          <ng-container *ngIf="element.device_properties.keypad">
            <img
              *ngIf="element.device_properties.keypad.online"
              src="assets/iconography/online-antenna.svg"
              class="device-status-icon"
              alt="online" />
            <img
              *ngIf="!element.device_properties.keypad.online"
              src="assets/iconography/offline-antenna.svg"
              class="device-status-icon"
              alt="offline"
              [matTooltip]="element.issues | deviceIssuesTooltip" />
          </ng-container>
        </div>
      </td>
    </ng-container>

    <!-- Properties Column -->
    <ng-container matColumnDef="properties">
      <th mat-header-cell *matHeaderCellDef>Properties</th>
      <td mat-cell *matCellDef="let element">
        <div style="display: inline-block">
          <sbnb-avatar-group [items]="element.properties" [itemsForLabel]="element.name"></sbnb-avatar-group>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.double-height-row]="row.device_properties.keypad"
      (click)="nameClicked.emit({ deviceId: row.id, deviceType: row.device_type })"></tr>
  </table>
</div>

<div *ngIf="isMobile$ | async" class="mobile-devices-table">
  <mat-card *ngFor="let device of devices; trackBy: trackDevice">
    <mat-card-content (click)="nameClicked.emit({ deviceId: device.id, deviceType: device.device_type })">
      <div fxLayout="column" fxLayoutGap="12px">
        <div fxLayoutAlign="space-between center" fxLayoutGap="12px">
          <a class="strong ellipsis">{{ device.name }}</a>
          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
            <img
              *ngIf="device.device_properties.online"
              src="assets/iconography/online-antenna.svg"
              class="device-status-icon"
              alt="online" />
            <img
              *ngIf="!device.device_properties.online"
              src="assets/iconography/offline-antenna.svg"
              class="device-status-icon"
              alt="offline"
              [matTooltip]="device.issues | deviceIssuesTooltip" />
            <sbnb-device-battery-status [battery]="device.device_properties.battery"></sbnb-device-battery-status>
          </div>
        </div>
      </div>

      <div style="display: inline-block">
        <sbnb-avatar-group [items]="device.properties" [itemsForLabel]="device.name"></sbnb-avatar-group>
      </div>
    </mat-card-content>
  </mat-card>
</div>
